import { render } from "./BaseTextInput.vue?vue&type=template&id=741e71f5"
import script from "./BaseTextInput.vue?vue&type=script&lang=ts"
export * from "./BaseTextInput.vue?vue&type=script&lang=ts"

import "./BaseTextInput.vue?vue&type=style&index=0&id=741e71f5&lang=scss"
script.render = render

export default script